import HollerWPPlatform from '../platform/holler-wp';

new HollerWPPlatform().init();
